import { addToGlobalConfig, getGlobalConfig } from './globalConfig';

export const STORAGE_KEY = 'peakworkSetExternalPartnerContext';
const PARAM = 'context';
const KNOWN_PARTNER_CONTEXTS = ['bosys'];

/**
 * Resolves the external partner context and publishes it to the global
 * config so every micro frontend, library and utility can read it.
 *
 * Checks first for an existing "context" query parameter in the current
 * URL. If present and it is one of the known partner contexts
 * (KNOWN_PARTNER_CONTEXTS), it always wins: the value is (re-)persisted
 * to the local storage item "peakworkSetExternalPartnerContext" so it
 * survives the whole login session (navigation/refresh/new tab), and is
 * used as the current value.
 *
 * If the query parameter is not present, empty, or not a known partner
 * context, it falls back to the value already stored in the local
 * storage (if any). An absent, empty or unknown "context" param is
 * therefore never persisted and never clobbers an already stored
 * context.
 *
 * @returns {undefined}
 */
export function setExternalPartnerContext() {
  const param = new URLSearchParams(window.location.search).get(PARAM);
  let value;

  if (param && KNOWN_PARTNER_CONTEXTS.includes(param)) {
    window.localStorage.setItem(STORAGE_KEY, param);
    value = param;
  } else {
    value = window.localStorage.getItem(STORAGE_KEY);
  }

  addToGlobalConfig('externalPartnerContext', value);
}

export function getExternalPartnerContext() {
  return getGlobalConfig('externalPartnerContext') ?? null;
}
